import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

export const WebviewAuthenticationLayout = () => (
  <div className="flex h-screen w-full items-center justify-center text-center">
    <Typography.TitleMd color="text-default">
      {t("authenticating")}
    </Typography.TitleMd>
  </div>
);
